module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_EE-ba084b57b74927a754605545c7059668.svg";